import React from "react";
import { useSelector } from "react-redux";
import { IRootState } from "shared/reducer";
import { hasAnyAuthority } from "components/PrivateRoute/indext";

interface IAuthorizedProps {
	children: JSX.Element[] | JSX.Element;
	hasAnyAuthorities: Array<string>;
}

const Authorized: React.FC<IAuthorizedProps> = ({ children, hasAnyAuthorities }) => {
	const { account, isAuthenticated } = useSelector(
		(state: IRootState) => state.authentication
	);
	const isAuthorized = hasAnyAuthority([account.role], hasAnyAuthorities);

	if (isAuthorized && isAuthenticated) {
		return <React.Fragment>{children}</React.Fragment>;
	} else {
        return <React.Fragment/>
    }
};

export default Authorized;
